<template>
    <div>
        <el-dialog :visible.sync="psStoreDetailDialog" width="50%" top="8vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog">
        <el-card>
            <el-tabs type="card" v-model="modelValue">
                <el-tab-pane>
                    <span slot="label" name="1"><i class="el-icon-bank-card"></i> 门店详情</span>
                    <div style="height: 600px; overflow: auto">
                        <el-form label-position="left">
                            <el-row :gutter="0">
                                <el-divider content-position="left">代理信息</el-divider>
                            </el-row>  
                            <el-row :gutter="0">
                                <el-col :span="7"><el-form-item label="代理编号"><span>{{response.data.csCode}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="代理类型"><span >{{response.data.csType}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="代理名称"><span >{{response.data.csName}}</span></el-form-item></el-col>
                            </el-row>
                            <el-row :gutter="0">
                                <el-col :span="7"><el-form-item label="代理电话"><span>{{response.data.csPhone}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="开通分润"><span >{{response.data.csRewardFlag}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="分润比例"><span >{{response.data.csRewardPercent}}</span></el-form-item></el-col>
                            </el-row>
                            <el-row :gutter="0">
                                <el-divider content-position="left">商户信息</el-divider>
                            </el-row>  
                            <el-row :gutter="0">
                                <el-col :span="7"><el-form-item label="商户编号"><span>{{response.data.bsCode}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="商户类型"><span >{{response.data.bsType}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="商户名称"><span >{{response.data.bsName}}</span></el-form-item></el-col>
                            </el-row>
                            <el-row :gutter="0">
                                <el-col :span="7"><el-form-item label="商户电话"><span>{{response.data.bsPhone}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="商户分润"><span >{{response.data.bsRewardFlag}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="商户比例"><span >{{response.data.bsRewardPercent}}</span></el-form-item></el-col>
                            </el-row>
                            <el-row :gutter="0">
                                <el-divider content-position="left">BD信息</el-divider>
                            </el-row>  
                            <el-row :gutter="0">
                                <el-col :span="7"><el-form-item label="BD姓名"><span>{{response.data.bdName}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="BD电话"><span >{{response.data.bdPhone}}</span></el-form-item></el-col>
                            </el-row>
                            <el-row :gutter="0">
                                <el-divider content-position="left">门店信息</el-divider>
                            </el-row>  
                            <el-row :gutter="0">
                                <el-col :span="7"><el-form-item label="门店编号"><span>{{response.data.storeCode}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="门店名称"><span >{{response.data.storeName}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="门店单价"><span >{{response.data.unitPrice}}</span></el-form-item></el-col>
                            </el-row>
                            <el-row :gutter="0">
                                <el-col :span="7"><el-form-item label="封顶价格"><span>{{response.data.maxPrice}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="所在地区"><span >{{response.data.area}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="创建时间"><span>{{response.data.createTime | formatDate}}</span></el-form-item></el-col>
                            </el-row>
                            <el-row :gutter="0">
                                <el-col :span="7"><el-form-item label="门店品类"><span>{{response.data.category}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="是否连锁"><span >{{response.data.chainFlag}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="人均消费"><span >{{response.data.expense}}</span></el-form-item></el-col>
                            </el-row>
                            <el-row :gutter="0">
                                <el-col :span="7"><el-form-item label="联系人"><span>{{response.data.contactName}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="联系电话"><span >{{response.data.contactPhone}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="营业时间"><span >{{response.data.openTime}}</span></el-form-item></el-col>
                            </el-row>
                            <el-row :gutter="0">
                                <el-col :span="7"><el-form-item label="门店备注"><span >{{response.data.remark}}</span></el-form-item></el-col>
                                <el-col :span="13"><el-form-item label="详细地址"><span >{{response.data.address}}</span></el-form-item></el-col>
                            </el-row>
                            <el-row :gutter="0">
                                <el-col :span="24">
                                    <div style="height: 500px;width:100%;">
                                        <img :src="url" width="100%" height="100%"/>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </el-tab-pane>
                <el-tab-pane  v-loading="orderLoading"  element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"  
                        element-loading-background="rgba(0.8, 0, 0, 0.3)">
                    <span slot="label" name="2"><i class="el-icon-tickets"></i> 订单列表</span>
                    <div style="height: 600px; overflow: auto">
                        <el-form label-position="left">
                            <el-row :gutter="0">
                                <el-col :span="7"><el-form-item label="累计订单数量"><span>{{response.orderStatics.orders}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="累计订单金额"><span >{{response.orderStatics.orderMoneys}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="累计实付金额"><span >{{response.orderStatics.realPays}}</span></el-form-item></el-col>
                            </el-row>
                            <el-row :gutter="0">
                                <el-col :span="7"><el-form-item label="累计优惠金额"><span>{{response.orderStatics.discountMoneys}}</span></el-form-item></el-col>
                                <el-col :span="7"><el-form-item label="累计退款金额"><span >{{response.orderStatics.refundMoneys}}</span></el-form-item></el-col>
                            </el-row>
                        </el-form>
                        <el-table :data="response.orderList" style="margin:auto;width:calc(100% - 30px)" height="400" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                                :header-cell-style="{background:'#01DFD7',color:'#fff'}" >
                            <el-table-column label="订单编号" width="200" align="center" prop="orderId"></el-table-column>
                            <el-table-column label="订单金额" width="80" align="center" prop="orderMoney"></el-table-column>
                            <el-table-column label="实付金额" width="80" align="center" prop="realPayment"></el-table-column>
                            <el-table-column label="优惠金额" width="80" align="center" prop="discountMoney"></el-table-column>
                            <el-table-column label="租借时间" width="200" align="center">
                                <template slot-scope="scope">{{scope.row.rentTime | formatDate}}</template>
                            </el-table-column>
                            <el-table-column label="支付时间" width="200" align="center">
                                 <template slot-scope="scope">{{scope.row.payTime | formatDate}}</template>
                            </el-table-column>
                            <el-table-column label="归还时间" width="200" align="center">
                                <template slot-scope="scope">{{scope.row.returnTime | formatDate}}</template>
                            </el-table-column>
                            <el-table-column label="归还门店" width="200" align="center" prop="returnStoreName"></el-table-column>
                        </el-table>
                        <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-card>
        </el-dialog>
    </div>
</template>
<script>
import {getPsStoreDetail, getStoreStatics, getStoreOrders} from '../../api/storemanagement/psstore.js'
import {GLOBAL_URL} from '../../config/config.js'
import { formatDate } from "../../utils/date";
export default {
    data() {
        return {
            psStoreDetailDialog: false,
            loading: false,
            orderLoading: false,
            storeId: '',
            response: {data: [], orderStatics: '', orderList:[], total: 0},
            query: {current: 1,size: 10},
            url: '',
            modelValue: "0"
        }
    },
    methods: {
        init(id) {
            this.psStoreDetailDialog = true;
            this.storeId = id;
            getPsStoreDetail(id).then(result=>{
                this.url = GLOBAL_URL.imageUrl+result.data.headPic
                this.response.data = result.data;
                this.orders();
            })
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.psStoreDetailDialog = false;
            this.response.data = [];
            this.response.orderStatics = "";
            this.response.orderList = [];
            this.response.total = 0;
            this.modelValue = "0";
        },

        orders(){
            getStoreOrders(this.storeId,{current: this.query.current, size: this.query.size}).then(result=>{
                this.response.total = result.data.total;
                this.response.orderList = result.data.records;
                this.orderStatics();
            })
        },

        orderStatics(){
            getStoreStatics(this.storeId).then(result=>{
                this.response.orderStatics = result.data;
                this.loading = false;
            })
        },

        currenChangeHandle(value){
            this.query.current = value;
            getStoreOrders(this.storeId,{current: this.query.current, size: this.query.size}).then(result=>{
                this.response.total = result.data.total;
                this.response.orderList = result.data.records;
                this.loading = false;
            })
        }
    },
    filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  }
}
</script>
<style scoped>
.el-pagination{
    margin-left: 30%;
}
</style>>


// WEBPACK FOOTER //
// src/pages/storemanagement/psStoreDetail.vue